














































































































































































































































































































import { Component, Provide, Vue, Watch, Prop } from "vue-property-decorator";
import HttpClient from "@/API/HttpClient";
import { getCookie } from "@/JS/cookie"; //使用getCookie方法
import httpApi from "@/API/Tenant/Weixin";
import Bus from "@/JS/Bus";
@Component({
  components: {}
})
export default class extends Vue {
  @Prop() private propMessageCategory: any;
  @Prop() private propMessageObj!: any;
  @Prop() private propModifyIndex!: any;
  @Provide() messageTemplate: any = "";
  @Provide() mtCategory: string = "未分组";
  @Provide() customUrlIsTotal: boolean = true;
  @Provide() loading: boolean = false;
  @Provide() GetAppData: any = [];
  @Provide() mtRules: any = {
    template_name: [
      { required: true, message: "请输入活动名称", trigger: "blur" },
      { min: 3, max: 20, message: "长度在 3 到 5 个字符", trigger: "blur" }
    ],
    miniprogram: {
      appid: [{ required: true, message: "小程序ID不能为空", trigger: "blur" }],
      pagepath: [{ required: true, message: "路径不能为空", trigger: "blur" }]
    }
  };
  @Provide() emojiRes: any = {};
  @Provide() linkDialogVisible: boolean = false;
  @Provide() currentLinkTab: number = 0;
  @Provide() linkTypeList: any = ["智能表单"]; //"H5裂变", "疯狂砍价", "人人拼团"
  @Provide() formList: any = [
    {
      formName: "智能表单A",
      selectVal: "默认地址",
      links: [
        "默认地址",
        "https://h5.xiaodashi.com/activity/form/69?formId=308&carry=f87f0755f02f1ca31069462b63b3e3c2"
      ]
    },
    {
      formName: "智能表单B",
      selectVal: "默认地址",
      links: [
        "默认地址",
        "https://h5.xiaodashi.com/activity/form/69?formId=308&carry=f87f0755f02f1ca31069462b63b3e3c2"
      ]
    }
  ];
  @Provide() selectedLinkIndex: number = -1;
  @Provide() formSearchKeywords: string = "";
  @Provide() h5List: any = [
    {
      formName: "H5裂变A",
      selectVal: "默认地址",
      links: [
        "默认地址",
        "https://h5.xiaodashi.com/activity/form/69?formId=308&carry=f87f0755f02f1ca31069462b63b3e3c2"
      ]
    },
    {
      formName: "H5裂变B",
      selectVal: "默认地址",
      links: [
        "默认地址",
        "https://h5.xiaodashi.com/activity/form/69?formId=308&carry=f87f0755f02f1ca31069462b63b3e3c2"
      ]
    }
  ];
  @Watch("messageTemplate", { immediate: true, deep: true })
  //  监听公众号类型
  get tencentCode() {
    return this.$store.state.TencentInfoStore.typeCode;
  }
  @Watch("tencentCode", { immediate: false, deep: true })
  ontencentCode(val: string, oldVal: string) {
    // console.log("监听公众号类型: ");
    //console.log(val);
    //console.log(oldVal);
    this.$emit("cancelData");
    this.backStep("messageList");
  }
  onMessageTemplateChange(newTemplate: any, oldTemplate: any) {
    if (newTemplate != "") {
      localStorage.setItem("wxTemplate", JSON.stringify(newTemplate));
    }
  }
  @Provide() modifyIndex: string = "";
  /** 选择模板分类 */
  selectMtCategory() {
    this.messageTemplate.template_category = this.mtCategory;
  }
  /** 选择链接类型 */
  selectLinkType(clickLinkIndex: number) {
    this.currentLinkTab = clickLinkIndex;
  }
  created() {
    let Aid = getCookie("Aid");
    let TenantID = getCookie("TenantID");
    if (!TenantID) {
      TenantID = "0";
    }
    this.GetAppData = {
      TenantID: TenantID,
      Aid: Aid
    };
    this.GetCustomEmoji();
    if (localStorage.getItem("wxTemplate")) {
      this.messageTemplate = JSON.parse(localStorage.getItem("wxTemplate") as any);
    } else {
      this.propMessageObj.miniprogram = JSON.parse(
        this.propMessageObj.miniprogram
      );
      this.messageTemplate = JSON.parse(JSON.stringify(this.propMessageObj));
      localStorage.setItem("wxTemplate", JSON.stringify(this.propMessageObj));

      if (localStorage.getItem("modifyIndex")) {
        this.modifyIndex = localStorage.getItem("modifyIndex") as string;
      } else {
        this.modifyIndex = JSON.parse(JSON.stringify(this.propModifyIndex));
        localStorage.setItem(
          "modifyIndex",
          JSON.stringify(this.propModifyIndex)
        );
      }
      console.log("接收到的模板消息");
      console.log(this.messageTemplate);
      //this.messageTemplate.TypeId = 0;
      this.messageTemplate.TypeId = parseInt(this.propMessageObj.TypeID);
      var that = this;
      Bus.$off("switchAccountFn");
      Bus.$on("switchAccountFn", (obj: any) => {
        that.GetAppData.Aid = obj.Aid;
        that.$emit("cancelData");
        that.backStep("messageList");
      });
    }
  }
  /** 上一步,取消 */
  backStep(pageElement: string) {
    localStorage.removeItem("wxTemplate");
    this.$emit("pageEl", [pageElement, -1]);
  }
  addEmoji(emojiText: any) {
    this.messageTemplate.data[emojiText[0]].value += emojiText[1];
  }
  /*取消保存 */
  cancelData() {
    this.$emit("cancelData");
    this.backStep("messageList");
  }
  /** 提交模板消息  */
  async submitMessage(submitData: any) {
    (this.$refs["messageTemplate"] as any).validate(async (valid: any) => {
      if (valid) {
        //console.log(this.messageTemplate);
        // console.log(this.mtCategory);
        //保存数据
        this.$emit("messageData", submitData);
      } else {
        console.log("error submit!!");
        return false;
      }
    });
  }
  addFansName(dname: string) {
    let _this = this;
    dname == "first"
      ? (_this.messageTemplate.data.first.value += "[粉丝昵称]")
      : (_this.messageTemplate.data.remark.value += "[粉丝昵称]");
  }
  /*查询表情列表 */
  //加载表情
  async GetCustomEmoji() {
    let params: any = {
      Input: [
        {
          Name: "AppEmotionDTO",
          Value: {
            TenantID: this.GetAppData.TenantID
          } //消息模板类型
        }
      ]
    };
    //console.log(params);
    var res: any = await httpApi.GetCustomEmoji(params);
    //console.log(res);
    if (res.ErrorCode == 0) {
      this.emojiRes = res.output[0].value;
    } else {
      this.$message.error("取列表失败：" + res.ErrorMessage);
    }
  }
  /*验证正则 */
  GetOnkeyup(key: string) {
    switch (key) {
      case "letter":
        return "value=value.replace(/[^a-zA-Z]/g,'')";
      case "symbol":
        return "this.value=this.value.replace(/[^~!@#$%^&*()_+{}<>?.]+/,'');";
      case "character_string":
        return "value=value.replace(/[^a-zA-Z0-9]/g,'')";
      case "time":
        return "";
      case "date":
        return "";
      case "amount":
        return "this.value=this.value.replace(/[^0-9.]+/,'');";
      case "phone_number":
        return "this.value=this.value.replace(/[^0-9-]+/,'');";
      case "car_number":
        return "this.value=this.value.replace(/[^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4,5}[A-Z0-9挂学警港澳]{1}]/g,'')";
      case "name":
        return "value=value.replace(/[^a-zA-Z\u4E00-\u9FA5]/g,'')";
      case "phrase":
        return "value=value.replace(/[^\u4E00-\u9FA5]/g,'')";
      case "thing":
        return "value=value.replace(/[^a-zA-Z\u4E00-\u9FA5]/g,'')";
      case "number":
        return "this.value=this.value.replace(/[^d]/g,'')";
      default:
        return "";
    }
  }
  GetMaxLength(key: string) {
    switch (key) {
      case "letter":
        return 32;
      case "symbol":
        return 5;
      case "character_string":
        return 32;
      case "time":
        return 20;
      case "date":
        return 20;
      case "amount":
        return 11;
      case "phone_number":
        return 17;
      case "car_number":
        return 8;
      case "name":
        return 10;
      case "phrase":
        return 5;
      case "thing":
        return 20;
      case "number":
        return 32;
      default:
        return "";
    }
  }

  /** 颜色边界 */
  colorEdges(dataName:string){
    if(this.messageTemplate.data[dataName].color == null){
      this.messageTemplate.data[dataName].color = '#333';
    }
  }
}
